export default "Comparez les offres d'électricité et de gaz adaptées aux exploitations agricoles (serres, élevage, stockage). Estimation gratuite et accompagnement par un conseiller énergie.";
